import type { ExamLevelId } from './examAiParams';
import { EXAM_LEVEL_OPTIONS } from './examAiParams';
import type { MusicGenerationPrefs } from '@interactive-room';

export type RecipeDifficultyId = 'easy' | 'medium' | 'hard';

export interface RecipeDifficultyOption {
  id: RecipeDifficultyId;
  label: string;
  hint: string;
}

export const RECIPE_DIFFICULTY_OPTIONS: RecipeDifficultyOption[] = [
  { id: 'easy', label: 'Fácil', hint: 'Consignas directas, menos pasos y vocabulario accesible.' },
  { id: 'medium', label: 'Media', hint: 'Desafío equilibrado para el curso indicado.' },
  { id: 'hard', label: 'Alta', hint: 'Mayor profundidad, más ítems o ecuaciones más complejas.' },
];

export interface RecipeAiBuildOptions {
  level: ExamLevelId;
  difficulty: RecipeDifficultyId;
  tuning: string;
  musicPrefs?: MusicGenerationPrefs;
}

export { EXAM_LEVEL_OPTIONS };
